/**
 * Hides the Firefly editor's size / aspect-ratio picker (ADO-1412).
 *
 * Bridgeway only ever opens the editor on an EXISTING image (edit mode), where the
 * output is locked to the source size (`supportsResolutionForEdits: false`), so
 * the bundle renders that picker permanently `?disabled`. The factory already
 * hides the model picker, leaving the disabled size picker as the lone leading
 * control in the prompt bar — a dead dropdown the user can't use.
 *
 * There is no host config or feature seam to suppress it (the bundle's feature
 * flags are static and its factory exposes no such toggle), and the bundle is a
 * prebuilt artifact we don't compile. So we inject a `display:none` rule into
 * the editor's (open) shadow DOM — see {@link injectShadowCss}. `.size-resolution-container`
 * is the wrapper; the individual tags are belt-and-suspenders in case the
 * wrapper class changes. In edit mode the cluster's preceding `sp-divider` is
 * only rendered alongside the (hidden) model picker, so hiding the cluster
 * leaves no orphan separator.
 */

import {
	injectShadowCss,
	type ShadowStyleController,
} from './shadowStyleInjector';

const HIDE_RULE =
	[
		'.size-resolution-container',
		'firefly-image-editor-size-picker',
		'firefly-image-editor-resolution-picker',
		'firefly-image-editor-generation-quality-picker',
	].join(',') + '{display:none!important}';

export type SizePickerHider = ShadowStyleController;

export function hideDisabledSizePicker(
	container: HTMLElement,
): SizePickerHider {
	return injectShadowCss(container, {
		rule: HIDE_RULE,
		marker: 'data-ff-hide-size-picker',
	});
}
